"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesTicketCountExceedRemainingUses = exports.getNumberOfTicketsAffectedByDiscount = exports.doesDiscountApplyToTickets = exports.validateDiscountScope = exports.validateDiscountAmount = exports.getRatesToCheck = exports.isTicketEligibleForSpecificRates = void 0;
const ticketing_1 = require("../enums/ticketing");
const isTicketEligibleForSpecificRates = (ticket, selectedRateIds) => {
    if (selectedRateIds.includes(ticket.rateId)) {
        return true;
    }
    return Boolean(ticket.parentRateId && selectedRateIds.includes(ticket.parentRateId));
};
exports.isTicketEligibleForSpecificRates = isTicketEligibleForSpecificRates;
const getRatesToCheck = (scope, selectedRateIds, availableRates) => {
    const discountableRates = availableRates.filter((rate) => !rate.isPayWhatYouCan && !rate.isAddOn);
    if (scope === ticketing_1.DiscountScope.PerTicketAllRates) {
        return discountableRates;
    }
    if (selectedRateIds.length === 0) {
        return null;
    }
    return discountableRates.filter((rate) => selectedRateIds.includes(rate.id));
};
exports.getRatesToCheck = getRatesToCheck;
const validateDiscountAmount = (params) => {
    const { amount, type, scope, selectedRateIds, availableRates } = params;
    if (type !== ticketing_1.DiscountType.Dollars) {
        return { isValid: true };
    }
    if (scope === ticketing_1.DiscountScope.FullOrder) {
        return { isValid: true };
    }
    const ratesToCheck = (0, exports.getRatesToCheck)(scope, selectedRateIds, availableRates);
    if (!ratesToCheck || ratesToCheck.length === 0) {
        return { isValid: true };
    }
    const minRatePrice = Math.min(...ratesToCheck.map((rate) => rate.amount));
    if (amount > minRatePrice) {
        return {
            isValid: false,
            errorMessage: "Discount amount cannot exceed the minimum ticket price",
        };
    }
    return { isValid: true };
};
exports.validateDiscountAmount = validateDiscountAmount;
const validateDiscountScope = (scope, selectedRateIds) => {
    if (scope === ticketing_1.DiscountScope.PerTicketSpecificRates && selectedRateIds.length === 0) {
        return {
            isValid: false,
            errorMessage: "At least one rate must be selected when scope is per ticket specific rates",
        };
    }
    return { isValid: true };
};
exports.validateDiscountScope = validateDiscountScope;
const doesDiscountApplyToTickets = (discount, purchasedTickets) => {
    if (purchasedTickets.length === 0) {
        return false;
    }
    if (discount.scope === ticketing_1.DiscountScope.FullOrder) {
        return true;
    }
    const discountableTickets = purchasedTickets.filter((ticket) => !ticket.isAddOn);
    if (discountableTickets.length === 0) {
        return false;
    }
    if (discount.scope === ticketing_1.DiscountScope.PerTicketAllRates) {
        return true;
    }
    const selectedRateIds = discount.selectedRateIds;
    if (!selectedRateIds || selectedRateIds.length === 0) {
        return false;
    }
    return discountableTickets.some((ticket) => (0, exports.isTicketEligibleForSpecificRates)(ticket, selectedRateIds));
};
exports.doesDiscountApplyToTickets = doesDiscountApplyToTickets;
const getNumberOfTicketsAffectedByDiscount = (discount, purchasedTickets) => {
    if (discount.scope === ticketing_1.DiscountScope.FullOrder) {
        return 0;
    }
    const eligibleTickets = purchasedTickets.filter((ticket) => !ticket.isPayWhatYouCan && !ticket.isAddOn);
    const countTicketUses = (ticket) => ticket.quantity * (ticket.attendeesByTicket || 1);
    if (discount.scope === ticketing_1.DiscountScope.PerTicketAllRates) {
        return eligibleTickets.reduce((sum, ticket) => sum + countTicketUses(ticket), 0);
    }
    const selectedRateIds = discount.selectedRateIds;
    if (!selectedRateIds || selectedRateIds.length === 0) {
        return 0;
    }
    return eligibleTickets
        .filter((ticket) => (0, exports.isTicketEligibleForSpecificRates)(ticket, selectedRateIds))
        .reduce((sum, ticket) => sum + countTicketUses(ticket), 0);
};
exports.getNumberOfTicketsAffectedByDiscount = getNumberOfTicketsAffectedByDiscount;
const doesTicketCountExceedRemainingUses = (discount, purchasedTickets) => {
    const { remainingUses, scope } = discount;
    if (scope === ticketing_1.DiscountScope.FullOrder || remainingUses === null || remainingUses === undefined) {
        return false;
    }
    return (0, exports.getNumberOfTicketsAffectedByDiscount)(discount, purchasedTickets) > remainingUses;
};
exports.doesTicketCountExceedRemainingUses = doesTicketCountExceedRemainingUses;
